<template>
  <CustDialogBox
    @closed="dialogOnCloseFn"
    @opend="dialogOpendFn"
    :show="isShow"
    title="微信绑定"
    width="500"
  >
    <template #content>
      <div class="dialog_box">
        <div class="weixin">
          <div class="image-weixin">
            <el-image
              style="width: 100%; height: 100%"
              :src="qrcodeImg"
              :fit="'contain'"
            />
          </div>
          <div class="qrcode-tip">微信扫一扫，绑定账号</div>
        </div>
      </div>
    </template>
  </CustDialogBox>
</template>

<script setup>
import { ref } from 'vue'
import { getByUserName, smsLogin, getQrcode, getSignStatus } from '@/api/login'
import { userBindOpenId } from '@/api/manage/clinicSetting'
import { useUserStore } from '@/store/modules/user'
const userStore = useUserStore()
const emit = defineEmits(['closed', 'update:isShow'])
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
  type: {
    type: String,
    default: 'setting',
  },
})
const loading = ref(false)
const qrcodeImg = ref()
const qrcodeKey = ref()

let loginStatusTimer = null
let qrCodeTimer = null
// 二分钟1次更换二维码
const twoSecondFn = () => {
  if (qrCodeTimer) clearInterval(qrCodeTimer)
  getQrcodeFn()
  qrCodeTimer = setInterval(() => {
    clearInterval(loginStatusTimer)
    getQrcodeFn()
  }, 120000)
}
// 获取二维码
const getQrcodeFn = async () => {
  const res = await getQrcode()
  qrcodeImg.value = res.data.qrCodeUrl
  qrcodeKey.value = res.data.sceneStr
  loginStatusTimer = setInterval(() => {
    loopFn()
  }, 2000)
}
// 扫码状态
const loopFn = async () => {
  const res = await getSignStatus({ eventKey: qrcodeKey.value })
  if (res.code == 0 && res.data.status) {
    scanSuccessFn()
  }
}
// 扫码成功
const scanSuccessFn = async () => {
  const res = await userBindOpenId({ eventKey: qrcodeKey.value })
  if (res.code == 0) {
    ElMessage.success('绑定成功')
    userStore.setOpenId(res.data)
    dialogOnCloseFn()
  }
}
const dialogOpendFn = () => {
  twoSecondFn()
}
const dialogOnCloseFn = () => {
  emit('closed')
  emit('update:isShow', false)
  clearInterval(loginStatusTimer)
  clearInterval(qrCodeTimer)
}
</script>

<style lang="scss" scoped>
.dialog_box {
  width: 100%;
  padding: 10px 0;
  box-sizing: border-box;
}
.weixin {
  width: 100%;
  min-height: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;

  .image-weixin {
    width: 200px;
    height: 200px;
    margin: 0 0 12px 0;
    border-radius: 12px;
    padding: 8px;
    border: 1px solid #e4e7ed;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  }

  .qrcode-tip {
    font-size: 13px;
    color: #909399;
    margin-top: 6px;
  }
}
.dialog_footer {
  width: 100%;
  text-align: end;
  padding-bottom: 10px;
}
</style>
